import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PeriodSelector } from "./validated-revenues/PeriodSelector";
import { ValidatedAmountCard } from "./validated-revenues/ValidatedAmountCard";
import { PaymentMethodDetails } from "./validated-revenues/PaymentMethodDetails";
import { usePeriodDates } from "./validated-revenues/usePeriodDates";

export const ValidatedRevenuesTab = () => {
  const [selectedPeriod, setSelectedPeriod] = useState("day");
  const period = usePeriodDates(selectedPeriod);

  const { data: validatedAmounts, isLoading } = useQuery({
    queryKey: ["validated_amounts", selectedPeriod],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      const startDate = period.start.toISOString().split('T')[0];
      const endDate = period.end.toISOString().split('T')[0];

      console.log("Fetching validated amounts for period:", {
        startDate,
        endDate,
        selectedPeriod
      });

      const { data, error } = await supabase
        .from("validated_amounts")
        .select("*")
        .eq("owner_id", user.id)
        .eq("status", "validated")
        .gte("counting_date", startDate)
        .lte("counting_date", endDate)
        .order('counting_date', { ascending: false });

      if (error) {
        console.error("Error fetching validated amounts:", error);
        throw error;
      }

      console.log("Validated amounts found:", data);
      return data || [];
    },
    refetchInterval: 30000,
    staleTime: 0,
    gcTime: 0,
  });

  const totalAmount = validatedAmounts?.reduce((sum, item) => sum + item.amount, 0) || 0;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Chiffre d'affaires validé</h3>
        <PeriodSelector
          selectedPeriod={selectedPeriod}
          onPeriodChange={setSelectedPeriod}
        />
      </div>

      <ValidatedAmountCard
        isLoading={isLoading}
        totalAmount={totalAmount}
        periodLabel={period.label}
        selectedPeriod={selectedPeriod}
        validatedAmounts={validatedAmounts}
      />

      <PaymentMethodDetails validatedAmounts={validatedAmounts || []} />
    </div>
  );
};